// NOTE: the index is following the convention from moment.js
// duplicates:
// admin-client/src/monthsMap.js
// client/lib/components/contactFormLib/monthMap.js

const MONTHS_MAP = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December',
};

export default MONTHS_MAP;



// WEBPACK FOOTER //
// ./src/monthsMap.js